export default "__VITE_ASSET__743e0ed6__"